/**
 * TITA 扩展：社交运营（邀请码配额 / 安全工单）
 * 组件在 views/_expand/social；URL 仍挂在 /user 下以兼容菜单 path
 * 原挂载：router/modules/user.ts
 */
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

const socialRouter: RouteRecordRaw = {
  path: `${roterPre}/user`,
  name: 'userSocialExpand',
  // 侧栏仍由菜单/user 路由驱动；本记录仅注册 expand 页面，避免重复「用户管理」
  hidden: true,
  meta: {
    title: '用户管理',
  },
  component: Layout,
  children: [
    {
      path: 'invite_quota',
      name: 'UserInviteQuota',
      meta: {
        title: '邀请码配额',
        noCache: true,
      },
      component: () => import('@/views/_expand/social/invite-quota/index.vue'),
    },
    {
      path: 'safety_report',
      name: 'UserSafetyReport',
      meta: {
        title: '安全工单',
        noCache: true,
      },
      component: () => import('@/views/_expand/social/safety-report/index.vue'),
    },
  ],
};

export default socialRouter;
